import APIUrl from "../../../APIUrl";
import axios from "axios";

export const GET_GROUPS = "GET_GROUPS";

export function getGroupsAction(groups) {
  return { type: GET_GROUPS, groups: groups };
}

export const getGroups = function () {
  return function (dispatch) {
    return axios
      .get(APIUrl.getGroups)
      .then(function (response) {
        if (response) {
          dispatch(getGroupsAction(response.data));
        }
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const createGroup = function (data, successCallback, failureCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.createGroup, data)
      .then(function (response) {
        if (response) dispatch(getGroups());
        return successCallback();
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const updateGroup = function (data, successCallback, failureCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.updateGroup, data)
      .then(function (response) {
        if (response) dispatch(getGroups());
        return successCallback();
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const blockGroup = function (group_id) {
  return function (dispatch) {
    return axios
      .post(APIUrl.blockGroup, group_id)
      .then(function (response) {
        if (response) dispatch(getGroups());
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};
